export default __webpack_public_path__ + "static/media/fb.1b671bc6.svg";